// removed by extract-text-webpack-plugin
module.exports = {"btn-apex-primary":"Ifh0hz-V-yVbZy5tMhfKE","focus":"_1OKciMQ5Fxncu2R6ebAtWn","active":"_3K_rCqSyhUJ10ARCLks7ud","disabled":"_35hg5OK4ORq6TOBmasOZ_c","badge":"_3qDXTtz6arivvQpcHpwIq-","btn-apex-secondary":"_13lneOBOcI-XTO9aXCBxuH","btn-apex-secondary-no-hover":"_3yND8iExYQq2oMZl0QQPh3","btn-apex-negative":"_2Q6cEtTLE_-MEgbXP_1zZ","btn-apex-orange":"zvNGknY6i1-kNWQ2Xgm0e","rejectReason":"_3KLiV7TJFmzjaUCJKY6vJL","rejectReasonInput":"_10Vy_gjP-gPHLhDplE8WIy","commentLabel":"XzbnuawWjEa3W2FE_Nzlj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RejectTransferForm/styles.css
// module id = 3216
// module chunks = 0